import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer id='third-party-links'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'
          align='center'
          nextElement='typography'>
          Third Party Links
        </Typography>
        <Typography nextElement='typography'>
          Links to other websites are provided for your convenience and information only. When you click on a link
          to another website you will be leaving this website. The fact that we provide links to other websites
          does not mean that we endorse, authorize or sponsor the linked website, or that we are affiliated with
          that website&#39;s owners or sponsors. Unless otherwise indicated, the linked sites are not under our control
          and we are not responsible for and assume no liability for the content or presentation of any linked
          site or any link contained in a linked site, or any changes or updates to such sites. We make no representations
          about the accuracy or completeness of the information contained in any linked sites. We retain the right
          to remove links to other websites at any time.
        </Typography>
        <Typography disableBottomPadding>
          Included in the above are links to Facebook, LinkedIn and other social media sites solely for the purpose
          of helping site visitors learn more about our financial representatives. Except for information related
          to Northwestern Mutual, financial representative social media sites to which we provide a link are the
          responsibility of the individual financial representative and are not under our control.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
